<template>
	<section class="main-content intro">
		<div class="row">
			<div v-if="introImage.image" class="intro-image fade-animate fade-up">
				<picture>
					<source v-if="introImage.imageWebp" :srcset="introImage.imageWebp" type="image/webp" />
					<source :srcset="introImage.image" />
					<img loading="lazy" :src="introImage.image" :alt="introImage.imageAlt" />
				</picture>
			</div>
			<slot name="main-content">
				<div class="columns column12 align-center">
					<h1>{{ title }}</h1>
					<slot name="extra-heading" />
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	content: { type: String, default: '' },
	introImage: {
		type: Object,
		default: () => ({
			image: '',
			imageAlt: '',
			imageWebp: '',
		}),
	},
});
</script>

<style lang="scss" scoped>
.intro-image {
	margin: 0 auto 50px;

	img {
		width: 250px;
		max-width: 90vw;
	}
}

@media (max-width: 880px) {
	.intro {
		padding: 50px 0;
	}
}
</style>
